import { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import type { AIDefinitionsPluginState } from './types';

export function getInitialState(): AIDefinitionsPluginState {
	return {
		sessionId: '',
		keywordDecorations: DecorationSet.empty,
		isReadingAidsPopupOpen: false,
	};
}
